import React from 'react';

import { Icon } from '@chakra-ui/react';
import {
  MdPerson,
  MdHome,
  MdLock,
  MdAttachFile,
  MdCarRental
} from 'react-icons/md';

// Admin Imports
import MainDashboard from 'views/admin/default';
import DriverDetailComponent from 'views/admin/driverDetails/DriverDetailComponent';
import IncidentDetailComponent from 'views/admin/incidentDetails/IncidentDetailComponent';
import VehiclePage from 'views/admin/vehicleDetails/VehicleDetailComponent';
import PrechecklistPage from 'views/admin/checklistDetails/ChecklistDetailComponent';

const routes = [
  {
    name: 'Main Dashboard',
    layout: '/admin',
    path: '/default',
    icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
    component: <MainDashboard />,
  },
  {
    name: 'Driver Details',
    layout: '/admin',
    path: '/drivers',
    icon: (
      <Icon
        as={MdPerson}
        width="20px"
        height="20px"
        color="inherit"
      />
    ),
    component: <DriverDetailComponent />,
    secondary: true,
  },
  {
    name: 'Vehicle Details',
    layout: '/admin',
    icon: <Icon as={MdCarRental} width="20px" height="20px" color="inherit" />,
    path: '/vehicle-details',
    component: <VehiclePage />,
  },
  {
    name: 'Incident Details',
    layout: '/admin',
    path: '/incidents',
    icon: <Icon as={MdAttachFile} width="20px" height="20px" color="inherit" />,
    component: <IncidentDetailComponent />,
  },
  {
    name: 'Check Lists',
    layout: '/admin',
    path: '/checkLists',
    icon: <Icon as={MdLock} width="20px" height="20px" color="inherit" />,
    component: <PrechecklistPage />,
  },
];

export default routes;
